import React, { useRef } from 'react';
import Cookies from 'js-cookie';
// eslint-disable-next-line import/no-unresolved
import { Swiper, SwiperSlide } from 'swiper/react';
import SectionsInfo from '../SectionsInfo';
// eslint-disable-next-line import/no-unresolved
import 'swiper/css';
import DoctorCard from './DoctorCard';
import useWindowSize from '../../hooks/useWindowSize';

function OurTeam({ data, isDiagnosticCenter }) {
  const { width } = useWindowSize();
  const swiperRef = useRef(null);
  const lang = Cookies.get('i18next') || 'en';
  const handleNext = () => {
    if (swiperRef.current) swiperRef.current.slideNext();
  };
  // 7769
  const handlePrev = () => {
    if (swiperRef.current) swiperRef.current.slidePrev();
  };
  return (
    <div style={{ marginTop: isDiagnosticCenter ? '20px' : '' }} className="our__team">
      <div className="container small">
        <div className="our__team__content">
          <SectionsInfo
            handleNext={handleNext}
            handlePrev={handlePrev}
            isSlider
            title={data.title && data.title[lang]}
            description={data.content_title && data.content_title[lang]}
          />
          <Swiper
            loop
               // eslint-disable-next-line no-return-assign
            onSwiper={(swiper) => (swiperRef.current = swiper)}
            className="our__team-slider"
            spaceBetween={width > 768 ? 32 : 16}
            slidesPerView={width > 768 ? 4 : 1.1}
          >
            {[...data.data]
              .sort((a, b) => a.staff.position - b.staff.position)
              .map((item) => (
                <SwiperSlide key={item.staff.id}>
                  <DoctorCard item={item} />
                </SwiperSlide>
              ))}

          </Swiper>
        </div>
      </div>
    </div>
  );
}

export default OurTeam;
